import { createSelector } from 'reselect'

const selectImportDomain = (state) => state.get('importStatus')

const makeSelectGetUploadStatusError = () =>
  createSelector(selectImportDomain, (substate) =>
    substate.get('getUploadStatusError'),
  )
const makeSelectUploadStatus = () =>
  createSelector(selectImportDomain, (substate) =>
    Object.values(
      substate
        .get('uploadStatus')
        .filter((status) => !status.get('hidden'))
        .toJS(),
    ),
  )
const makeSelectNumberOfSucceeded = () =>
  createSelector(
    selectImportDomain,
    (substate) =>
      substate
        .get('uploadStatus')
        .filter(
          (status) =>
            (status.get('stage')?.toLowerCase() === 'succeeded' ||
              status.get('progressInPercent') === 100) &&
            !status.get('loaded'),
        ).size,
  )
const makeSelectUploadStatusQuickView = () =>
  createSelector(selectImportDomain, (substate) =>
    Object.values(
      substate
        .get('uploadStatus')
        .filter(
          (status) =>
            !status.get('hidden') && status.get('stage') !== 'Canceled',
        )
        .toJS(),
    ),
  )

const makeSelectDownloadStatus = () =>
  createSelector(selectImportDomain, (substate) =>
    Object.values(
      substate
        .get('downloadStatus')
        .filter((status) => !status.hidden)
        .map((status, id) => ({ ...status, id }))
        .toJS(),
    ),
  )

export {
  selectImportDomain,
  makeSelectGetUploadStatusError,
  makeSelectUploadStatus,
  makeSelectUploadStatusQuickView,
  makeSelectNumberOfSucceeded,
  makeSelectDownloadStatus,
}
